import { CollectionInViewSkeleton } from './CollectionInViewSkeleton';

// A generous upper bound — comfortably more than could ever fit in one row,
// even on an ultra-wide monitor. `flex-nowrap` (no wrap, default) +
// `overflow-hidden` (no JS measurement) means only however many actually fit
// the container's current width are visible; the rest are clipped, same as
// the real CollectionsInView carousel already showing a partial card at its
// scrollable edge.
const SKELETON_COUNT = 8;

export const CollectionsInViewSkeletonGrid = () => {
  return (
    <div className="mx-auto w-full max-w-[1400px] px-3 pt-4 sm:px-6">
      <div className="mb-3 h-6 w-32 animate-pulse rounded bg-black/10 dark:bg-white/10" />

      <div className="flex gap-[35px] overflow-hidden pb-4">
        {Array.from({ length: SKELETON_COUNT }, (_, index) => (
          <CollectionInViewSkeleton key={index} />
        ))}
      </div>
    </div>
  );
};
